module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-sm shadow",
    class: {
      'active': _vm.expandSummary
    }
  }, [_c('div', {
    staticClass: "order block",
    class: {
      'order--active': _vm.expandSummary, 'order--inactive': !_vm.expandSummary
    },
    on: {
      "click": function($event) {
        _vm.expandSummary = !_vm.expandSummary
      }
    }
  }, [_c('i', {
    staticClass: "order__icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "order__label"
  }, [_vm._v("รายการที่เลือกไว้\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expandSummary),
      expression: "!expandSummary"
    }],
    staticClass: "order__icon icon-arrow-down"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expandSummary),
      expression: "expandSummary"
    }],
    staticClass: "order__icon icon-arrow-up"
  })]), _vm._v(" "), _c('span', {
    staticClass: "order__label order__label--value fl-right"
  }, [_vm._v("\n      " + _vm._s(_vm._f("comma")(_vm.$utils.getCartGrandTotalPrice())) + "\n      "), _c('span', {
    staticClass: "order__label order__label--unit"
  }, [_vm._v("บาท")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expandSummary),
      expression: "expandSummary"
    }],
    staticClass: "slide-down-wrapper"
  }, [_c('div', {
    staticClass: "block-primary block slide-down-item"
  }, [_c('cart-summary')], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2d81d389", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d81d389","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentSummary.vue
// module id = 732
// module chunks = 1